import ApiServices from "../service";

export const callLog = {
  getPhoneLogs: (userId, accessToken, searchValue = null, pagination = null) => {
    const user = userId ? `user__in=${userId}` : "";
    const search = searchValue ? `${searchValue}` : "";
    const paginate = pagination ? `${pagination}` : "";

    const query = userId || search || paginate ? "?" : "";
    const deliminator = paginate ? "&" : "";
    const deliminator2 = search ? "&" : "";
    return ApiServices.getData(
      `/api/call_logs/${query}${user}${deliminator}${paginate}${deliminator2}${search}`,
      accessToken
    )
      .then((res) => res)
      .then((res) => res)
      .catch((err) => console.log(err));
  },

  getSMSLogs: (userId, accessToken, searchValue = null, pagination = null) => {
    const user = userId ? `user__in=${userId}` : "";
    const search = searchValue ? `${searchValue}` : "";
    const paginate = pagination ? `${pagination}` : "";

    const query = userId || search || paginate ? "?" : "";
    const deliminator = paginate ? "&" : "";
    const deliminator2 = search ? "&" : "";

    return ApiServices.getData(
      `/api/sms_messages/${query}${user}${deliminator}${paginate}${deliminator2}${search}`,
      accessToken
    )
      .then((res) => res)
      .then((res) => res)
      .catch((err) => console.log(err));
  },
};
